import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ActiveLog from './activityLog';
import { fetchRunInstanceHistory } from '../../../../../redux/actions/trm/trmDashboard';
import { fetchTypologiesActions } from '../../../../../redux/actions/common';

function mapStateToProps(state) {
  const { runInstanceHistoryList = {} } = state.trmDashboard;
  const { data, isLoading = true } = runInstanceHistoryList;
  return {
    runInstanceHistoryList: data,
    isLoading,
    trmActions: state.amlsCommon.commonTypologyAction,
    authentication: state.authentication
  };
}

function mapDispatchToProps(dispatch) {
  return {
    apiActions: bindActionCreators(
      {
        fetchRunInstanceHistory,
        fetchTypologiesActions
      },
      dispatch
    )
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ActiveLog);
